export default __webpack_public_path__ + "images/M2.2b7a162.png";